const CHECKOUT_SUMMARY_STORAGE_KEY = `checkout_summary_${window.SITE_ID}`;

export const getCheckoutSummaryFromStorage = () => {
  try {
    const stored = localStorage.getItem(CHECKOUT_SUMMARY_STORAGE_KEY);

    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.warn('Failed to parse checkout summary from localStorage:', error);

    return {};
  }
};

export const saveCheckoutSummaryToStorage = (checkoutSummary: any) => {
  try {
    localStorage.setItem(CHECKOUT_SUMMARY_STORAGE_KEY, JSON.stringify(checkoutSummary));
  } catch (error) {
    console.warn('Failed to save checkout summary to localStorage:', error);
  }
};

export const clearCheckoutSummaryStorage = () => {
  try {
    localStorage.removeItem(CHECKOUT_SUMMARY_STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear checkout summary from localStorage:', error);
  }
};
